<template>
	<!-- 提议 -->
	<div>
		<div class="">
			<van-cell is-link :title="title" @click="show = true" />
			<van-action-sheet v-model="show" :actions="actions" @select="onSelect" />
		</div>
		<div class="">
			<van-cell title="联系方式"  />
			<!-- 输入手机号，调起手机号键盘 -->
			<van-field
			    v-model="phone"
			    required
			    placeholder="请输入手机号"
			    :error-message="phoneErr"
			  />
		</div>
		<div>
			<van-cell title="请输入投诉或建议内容"  />
			<van-field
			  v-model="message"
			  rows="2"
			  autosize
			  type="textarea"
			  maxlength="100"
			  placeholder="请输入投诉或建议内容"
			  show-word-limit
			/>
		</div>
		<div class="intell-box">
			<van-button type="primary" block @click="submit">提交内容</van-button>
		</div>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				actions: [{ name: '投诉',val:0 }, { name: '建议',val:1 }],
				show:0,
				title:'请选择投诉类型',
				val :'',
				message:'',
				phone:'',
				phoneErr:''
			}
		},
		created() {
		},
		methods:{
			onSelect(item) {
				// 默认情况下点击选项时不会自动收起
				// 可以通过 close-on-click-action 属性开启自动收起
				this.show = false;
				this.title = item.name;
				this.val = item.val;
				console.log(item);
				this.$toast(item.name);
			},
			/**
			 * 检查手机格式是否正确
			 * @param {Object} phone
			 */
			isPhone(phone){
				if (!/^1[3|4|5|6|7|8|9][0-9]{9}$/.test(phone)) {
					return false;
				} else {
					return true;
				}
			},
			// 投诉。留言
			submit(text,type=1){
				if(this.val===''){
					this.$toast('请选择投诉类型');
					return
				}
				if(!this.isPhone(this.phone)){
					this.phoneErr = '手机号格式错误';
					return
				}else{
					this.phoneErr = '';
				}
				if(this.message === ''){
					this.$toast('请输入留言');
					return
				}
				let params = {
					"types": this.val,
					"phone": this.phone,
					"comment" :this.message,
					"source": this.source
				}
				console.log(params);
				this.$httpRequest.request(
					'yxm/com/yxm/v1/leave/insertLeaveWord',
					params,
					true,
					'POST',
					(response)=>{
						if(response.data.success){
							this.phone="";
							this.message="";
							this.$toast(response.data.msg);
						}else{
							this.$toast(response.data.msg);
						}
					}
				);
			},
		}
	}
</script>

<style lang="less" scoped>
	.intell-box{
		box-sizing: border-box;
		position: fixed;
		bottom: 0;
		left: 0;
		right: 0;
		
		width: 100%;
		
	}
</style>



// WEBPACK FOOTER //
// src/page/soule/intelligent-chat/suggest.vue